module.exports = __webpack_public_path__ + "static/042-97be1d2fd46e6d08ab70a64a1f7034ea.jpg";